import { render } from "./index.vue?vue&type=template&id=a9c4db46&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a9c4db46&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c4db46"],['__file',"src/vab/components/VabLock/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9c4db46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9c4db46', __exports__)) {
    console.log('reload')
    api.reload('a9c4db46', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a9c4db46&scoped=true", () => {
    console.log('re-render')
    api.rerender('a9c4db46', render)
  })

}


export default __exports__